import AccessDenied from "../views/403.vue";
import NotFound from "../views/404.vue";

export default [
  {
    path: "/",
    name: "welcome",
    meta: {
      name: "Добро пожаловать",
      access: ["seller", "owner"]
    },
    component: () => import("@/views/viewWelcome/ViewWelcome.vue"),
  },
  {
    path: "/aboutCompany",
    name: "aboutCompany",
    meta: {
      name: "О компании",
      access: ["seller", "owner"]
    },
    component: () => import("@/views/viewAbout/ViewAbout.vue"),
  },
  {
    path: "/newsList",
    name: "newsList",
    meta: {
      name: "Новости",
      access: ["seller", "owner"]
    },
    component: () => import("@/views/viewStaticNews/ViewNewsStaticList.vue"),
  },
  {
    path: "/newsList/:id",
    name: "newsListID",
    meta: {
      name: "Новость",
      access: ["seller", "owner"]
    },
    component: () => import("@/views/viewStaticNews/ViewNewsStaticID.vue"),
  },
  {
    path: "/serviceSupport",
    name: "serviceSupport",
    meta: {
      name: "Служба поддержки",
      access: ["owner"]
    },
    component: () => import("@/views/viewServiceSupport/ViewServiceSupport.vue")
  },
  {
    path: "/userProfile",
    name: "userProfile",
    meta: {
      name: "Профиль",
    },
    component: () => import("@/views/viewProfile/ViewProfile.vue"),
  },
  {
    path: "/documentation",
    name: "documentation",
    meta: {
      name: "Документация",
      access: ["owner"]
    },
    component: () => import("@/views/viewDocuments/ViewDocuments.vue")
  },
  {
    path: "/myOrders",
    name: "myOrders",
    meta: {
      name: "Мои заказы",
      access: ["admin", "owner"]
    },
    component: () => import("@/views/viewMyOrders/ViewMyOrders.vue"),
  },
  {
    path: "/myOrders/:id",
    name: "myOrdersID",
    meta: {
      name: "Мои заказы",
      access: ["admin", "owner"]
    },
    component: () => import("@/views/viewMyOrders/ViewMyOrdersID.vue"),
  },
  {
    path: "/certificates",
    name: "certificates",
    meta: {
      name: "Сертификаты",
      access: ["owner"]
    },
    component: () => import("@/views/viewCertificates/ViewCertificates.vue"),
  },
  {
    path: "/certificates/:id",
    name: "certificatesID",
    meta: {
      name: "Сертификаты",
      access: ["owner"]
    },
    component: () => import("@/views/viewCertificates/ViewCertificatesID.vue"),
  },
  {
    path: "/sellersList",
    name: "sellersList",
    meta: {
      name: "Продавцы",
      access: ["admin", "owner", "tsm_user"]
    },
    component: () => import("@/views/viewSellers/viewSellersList.vue"),
  },
  {
    path: "/sellersGroups",
    name: "sellersGroups",
    meta: {
      name: "Группы продавцов",
      access: ["admin", "owner", "tsm_user"]
    },
    component: () => import("@/views/viewSellers/viewSellersGroups.vue"),
  },
  {
    path: "/sellers/:id",
    name: "sellersID",
    meta: {
      name: "Продавец",
      access: ["admin", "owner", "tsm_user"]
    },
    component: () => import("@/views/viewSellers/viewSellersID.vue"),
  },
  {
    path: "/sellersGroups/:id",
    name: "sellersGroupsID",
    meta: {
      name: "Продавец",
      access: ["admin", "owner", "tsm_user"]
    },
    component: () => import("@/views/viewSellers/viewSellersGroupsID.vue"),
  },
  {
    path: "/usersModerationSelfRegistred",
    name: "usersModerationSelfRegistred",
    meta: {
      name: "Заявки на регистрацию",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewUsersModeration/ViewUsersModerationSelfRegistred.vue"),
  },
  {
    path: "/usersModerationSelfRegistred/:id",
    name: "usersModerationSelfRegistredID",
    meta: {
      name: "Пользователь",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewUsersModeration/ViewUsersModerationSelfRegistredID.vue"),
  },
  {
    path: "/usersModerationNewRequests",
    name: "usersModerationNewRequests",
    meta: {
      name: "Модерация пользователей",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewUsersModeration/viewUsersAdd.vue"),
  },
  {
    path: "/usersModerationNewRequests/:id",
    name: "usersModerationNewRequestsID",
    meta: {
      name: "Продавец",
      access: ["admin", "moderator",]
    },
    component: () => import("@/views/viewSellers/viewSellersID.vue"),
  },
  {
    path: "/usersModerationRequests",
    name: "usersModerationRequests",
    meta: {
      name: "Модерация пользователей",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewUsersModeration/ViewUsersModeration.vue"),
  },
  {
    path: "/usersModerationRequests/:id",
    name: "usersModerationRequestsID",
    meta: {
      name: "Продавец",
      access: ["admin", "moderator",]
    },
    component: () => import("@/views/viewUsersModeration/ViewUsersModerationID.vue"),
  },
  {
    path: "/usersGroupsList",
    name: "usersGroupsList",
    meta: {
      name: "Группы пользователей",
      access: ["admin"]
    },
    component: () => import("@/views/viewUsersGroups/viewUsersGroups.vue"),
  },
  {
    path: "/userGroups/:id",
    name: "usersGroupsID",
    meta: {
      name: "Просмотр группы",
      access: ["admin"]
    },
    component: () => import("@/views/viewUsersGroups/viewUsersGroupsID.vue"),
  },
  {
    path: "/owners",
    name: "owners",
    meta: {
      name: "Контрагенты",
      access: ["admin", "tsm_user"]
    },
    component: () => import("@/views/viewOwners/ViewOwners.vue"),
  },
  {
    path: "/TTmod",
    name: "TTmod",
    meta: {
      name: "Управление данными TT",
      access: ["admin", "tsm_user"]
    },
    component: () => import("@/views/viewTTMod/viewTTMod.vue"),
  },
  {
    path: "/owners/:id",
    name: "ownersID",
    meta: {
      name: "Контрагент",
      access: ["admin", "tsm_user"]
    },
    component: () => import("@/views/viewOwners/ViewOwnersID.vue"),
  },
  {
    path: "/owners/add",
    name: "ownersAdd",
    meta: {
      name: "Добавить контрагентов",
      access: ["admin"]
    },
    component: () => import("@/views/viewOwners/ViewOwnersAdd.vue"),
  },
  {
    path: "/tradePointsList",
    name: "tradePointsList",
    meta: {
      name: "Торговые точки",
      access: ["tsm_user", "moderator", "owner", "admin"]
    },
    component: () => import("@/views/viewTradePoints/ViewTradePoints.vue"),
  },
  {
    path: "/tradePointsList/:id",
    name: "tradePointsListID",
    meta: {
      name: "Торговая точка",
      access: ["tsm_user", "moderator", "owner", "admin"]
    },
    component: () => import("@/views/viewTradePoints/ViewTradePointID.vue")
  },
  {
    path: "/tradePointsGroups",
    name: "tradePointsGroups",
    meta: {
      name: "Группы торговых точек",
      access: ["admin"]
    },
    component: () => import("@/views/viewTradePointsGroups/ViewTradePointsGroupList.vue"),
  },
  {
    path: "/tradePointsGroups/:id",
    name: "tradePointsGroupsID",
    meta: {
      name: "Группа торговых точек",
      access: ["admin"]
    },
    component: () => import("@/views/viewTradePointsGroups/ViewTradePointsGroupID.vue"),
  },
  {
    path: "/tradePointsGroups/static/:id",
    name: "tradePointsGroupsStaticID",
    meta: {
      name: "Группа торговых точек",
      access: ["admin"]
    },
    component: () => import("@/views/viewTradePointsGroups/ViewTradePointsGroupStaticID.vue"),
  },
  {
    path: "/tradePointsGroupsEdit/:id",
    name: "tradePointsGroupsEdit",
    meta: {
      name: "Редактировать группы торговых точек",
      access: ["admin"]
    },
    component: () => import("@/views/viewTradePointsGroups/ViewTradePointGroupEdit.vue"),
  },
  {
    path: "/tradePointsGroupsNew",
    name: "tradePointsGroupsNew",
    meta: {
      name: "Создать группу торговых точек",
      access: ["admin"]
    },
    component: () => import("@/views/viewTradePointsGroups/ViewTradePointsGroupNew.vue"),
  },
  {
    path: "/TPModeration",
    name: "TPModeration",
    meta: {
      name: "Модерация торговых точек",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewTradePointsModeration/ViewTradePointsModeration.vue")
  },
  {
    path: "/TPModeration/:id",
    name: "TPModerationID",
    meta: {
      name: "Модерация торговой точки",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewTradePointsModeration/ViewTradePointModerationID.vue")
  },
  {
    path: "/TTmod",
    name: "TTmod",
    meta: {
      name: "Управление данными TT",
      access: ["admin"]
    },
    component: () => import("@/views/viewTTMod/viewTTMod.vue")
  },
  {
    path: "/tasksModeration",
    name: "tasksModeration",
    meta: {
      name: "Модерация заданий",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewTaskModeration/ViewTasksModeration.vue")
  },
  {
    path: "/buyersModeration",
    name: "buyersModeration",
    meta: {
      name: "Опросы (Покупатели)",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewBuyersTaskModeration/ViewBuyersTasksModeration.vue")
  },
  {
    path: "/tasksModeration/:id",
    name: "tasksModerationID",
    meta: {
      name: "Проверка задания",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewTaskModeration/ViewTasksModerationID.vue")
  },
  {
    path: "/buyersModeration/:id",
    name: "buyersModerationID",
    meta: {
      name: "Проверка опроса",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewBuyersTaskModeration/ViewBuyersTasksModerationID.vue")
  },
  {
    path: "/tasksControl",
    name: "tasksControl",
    meta: {
      name: "Задания",
      access: ["admin"]
    },
    component: () => import("@/views/viewTasks/ViewTasksControl.vue")
  },
  {
    path: "/tasksControl/default/:id",
    name: "tasksControlDefaultID",
    meta: {
      name: "Задание",
      access: ["admin"]
    },
    component: () => import("@/views/viewTasks/ViewTasksControlDefaultID.vue")
  },
  {
    path: "/tasksControl/control/:id",
    name: "tasksControlControlID",
    meta: {
      name: "Задание",
      access: ["admin"]
    },
    component: () => import("@/views/viewTasks/ViewTasksControlControlID.vue")
  },
  {
    path: "/reports",
    name: "reports",
    meta: {
      name: "Отчеты",
      access: ["admin"]
    },
    component: () => import("@/views/viewReports/ViewReports.vue")
  },
  {
    path: "/manuals",
    name: "manuals",
    meta: {
      name: "Справочники",
      access: ["admin"]
    },
    component: () => import("@/views/viewManuals/ViewManuals.vue")
  },
  {
    path: "/manuals/sku",
    name: "sku",
    meta: {
      name: "Справочники",
      access: ["admin"]
    },
    component: () => import("@/views/viewManuals/ViewManualsID.vue")
  },
  {
    path: "/manuals/prizes",
    name: "prizes",
    meta: {
      name: "Приз",
      access: ["admin"]
    },
    component: () => import("@/views/viewManuals/ViewPrizesID.vue")
  },
  {
    path: "/logs",
    name: "logs",
    meta: {
      name: "Логирование",
      access: ["admin"]
    },
    component: () => import("@/views/viewLogs/ViewLogs.vue")
  },
  {
    path: "/pushes",
    name: "pushes",
    meta: {
      name: "Push уведомления",
      access: ["admin"]
    },
    component: () => import("@/views/viewPushes/ViewPushes.vue")
  },
  {
    path: "/coinsAndFlames",
    name: "coinsAndFlames",
    meta: {
      name: "Операции с монетами/огоньками",
      access: ["admin"]
    },
    component: () => import("@/views/viewCoinOperation/viewCoinOperation.vue")
  },
  {
    path: "/geofences",
    name: "geofences",
    meta: {
      name: "Координаты",
      access: ["admin"]
    },
    component: () => import("@/views/viewGeofences/viewGeofences.vue")
  },
  {
    path: "/geofences/:id",
    name: "geofencesID",
    meta: {
      name: "Координаты",
      access: ["admin"]
    },
    component: () => import("@/views/viewGeofences/viewGeofencesID.vue")
  },
  {
    path: "/ratings",
    name: "ratings",
    meta: {
      name: "Рейтинги",
      access: ["admin"]
    },
    component: () => import("@/views/viewRatings/ViewRatings.vue")
  },
  {
    path: "/articles",
    name: "articles",
    meta: {
      name: "Статьи",
      access: ["admin"]
    },
    component: () => import("@/views/viewArticles/ViewArticles.vue")
  },
  {
    path: "/articles/add",
    name: "articlesAdd",
    meta: {
      name: "Создать статью",
      access: ["admin"]
    },
    component: () => import("@/views/viewArticles/ViewArticlesAdd.vue")
  },
  {
    path: "/articles/:id",
    name: "articlesID",
    meta: {
      name: "Редактировать статью",
      access: ["admin"]
    },
    component: () => import("@/views/viewArticles/ViewArticlesEdit.vue")
  },
  {
    path: "/banners",
    name: "banners",
    meta: {
      name: "Баннеры",
      access: ["admin"]
    },
    component: () => import("@/views/viewBanners/ViewBanners.vue")
  },
  {
    path: "/banners/:id",
    name: "bannersID",
    meta: {
      name: "Баннер",
      access: ["admin"]
    },
    component: () => import("@/views/viewBanners/viewBannersID.vue")
  },
  {
    path: "/competitions",
    name: "competitions",
    meta: {
      name: "Соревнования",
      access: ["admin"]
    },
    component: () => import("@/views/viewCompetitions/ViewCompetitions.vue")
  },
  {
    path: "/competitions/:id",
    name: "competitionsID",
    meta: {
      name: "Соревнование",
      access: ["admin"]
    },
    component: () => import("@/views/viewCompetitions/ViewCompetitionsID.vue")
  },
  {
    path: "/superPro",
    name: "superPro",
    meta: {
      name: "Супер Про",
      access: ["admin"]
    },
    component: () => import("@/views/viewSuperPro/ViewSuperPro.vue")
  },
  {
    path: "/ambassadors",
    name: "ambassadors",
    meta: {
      name: "Амбассадоры",
      access: ["admin"]
    },
    component: () => import("@/views/viewAmbassadors/ViewAmbassadors.vue")
  },
  {
    path: "/pushes/create",
    name: "pushesCreate",
    meta: {
      name: "Создать Push уведомление",
      access: ["admin"]
    },
    component: () => import("@/views/viewPushes/ViewPushesCreate.vue")
  },
  {
    path: "/pushes/edit/:id",
    name: "pushesEdit",
    meta: {
      name: "Редактировать Push уведомление",
      access: ["admin"]
    },
    component: () => import("@/views/viewPushes/ViewPushesEdit.vue")
  },
  {
    path: "/pushes/:id",
    name: "pushID",
    meta: {
      name: "Push уведомление",
      access: ["admin"]
    },
    component: () => import("@/views/viewPushes/ViewPushID.vue")
  },
  {
    path: "/newsConstructor",
    name: "newsConstructor",
    meta: {
      name: "Новости",
      access: ["admin"]
    },
    component: () => import("@/views/viewNewsConstructor/ViewNewsConstructor.vue")
  },
  {
    path: "/newsConstructor/add",
    name: "newsConstructorAdd",
    meta: {
      name: "Создать новость",
      access: ["admin"]
    },
    component: () => import("@/views/viewNewsConstructor/ViewNewsConstructorAdd.vue")
  },
  {
    path: "/newsConstructor/:id",
    name: "newsConstructorID",
    meta: {
      name: "Редактировать новость",
      access: ["admin"]
    },
    component: () => import("@/views/viewNewsConstructor/ViewNewsConstructorEdit.vue")
  },
  {
    path: "/tradeUsers",
    name: "tradeUsers",
    meta: {
      name: "Пользователи",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewUsers/ViewUsers.vue")
  },
  {
    path: "/tradeUsers/:id",
    name: "tradeUsersID",
    meta: {
      name: "Пользователь",
      access: ["admin", "moderator",]
    },
    component: () => import("@/views/viewUsers/ViewUsersID.vue"),
  },
  {
    path: "/tsmRequests",
    name: "tsmRequests",
    meta: {
      name: "Запросы",
      access: ["tsm_user"]
    },
    component: () => import("@/views/viewTsmRequests/ViewTsmRequests.vue")
  },
  {
    path: "/tsmGroups",
    name: "tsmGroups",
    meta: {
      name: "Группы торговых представителей",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewUsers/ViewTsmGroupList.vue")
  },
  {
    path: "/tsmGroupModerations",
    name: "tsmGroupModerations",
    meta: {
      name: "Модерация TSM",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewUsers/ViewTsmGroupModerationList.vue")
  },
  {
    path: "/tsmGroups/:id",
    name: "tsmGroupsID",
    meta: {
      name: "Группы торговых представителей",
      access: ["admin", "moderator"]
    },
    component: () => import("@/views/viewUsers/ViewTsmGroupsID.vue")
  },
  {
    path: "/editableCertificates",
    name: "editableCertificates",
    meta: {
      name: "Сертификаты",
      access: ["admin"]
    },
    component: () => import("@/views/viewCertificates/ViewEditableCertificates.vue")
  },
  {
    path: "/skuGroups",
    name: "skuGroups",
    meta: {
      name: "Группы ассортимента",
      access: ["admin"]
    },
    component: () => import("@/views/viewSKUGroups/ViewSKUGroups.vue"),
  },
  {
    path: "/skuGroups/:id",
    name: "SKUGroupsID",
    meta: {
      name: "Группы ассортимента",
      access: ["admin"]
    },
    component: () => import("@/views/viewSKUGroups/ViewSKUGroupsID.vue"),
  },
  {
    path: "/skuGroups/add",
    name: "SKUGroupsAdd",
    meta: {
      name: "Группы ассортимента",
      access: ["admin"]
    },
    component: () => import("@/views/viewSKUGroups/ViewSKUGroupsAdd.vue"),
  },
  {
    path: "/skuGroups/edit/:id",
    name: "SKUGroupsEdit",
    meta: {
      name: "Группы ассортимента",
      access: ["admin"]
    },
    component: () => import("@/views/viewSKUGroups/ViewSKUGroupsEdit.vue"),
  },
  {
    path: "/403",
    name: "accessDenied",
    meta: {
      name: "403 - Не достаточно прав",
    },
    component: AccessDenied,
  },
  {
    path: "/404",
    name: "notFound",
    meta: {
      name: "404 - Страница не найдена",
    },
    component: NotFound,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404"
  },
]
